export default "__VITE_ASSET__d8014e1e__"